import styled from 'styled-components';

/**
 * The breadcrumb and the tabs are laid out in flow above the list, so the page has to be a flex
 * column: with a plain `height: 100%` on the list container their 80px would overflow the viewport
 * and push the last row and the paginator below the fold.
 */
export const PageContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
`;
